/** Strip env noise (common copy/paste: trailing newline breaks Realtime ?apikey=…). */
export function normalizeSupabaseUrl(raw: string | undefined): string {
  return String(raw ?? '')
    .trim()
    .replace(/\/+$/, '');
}

/** Anon/service keys must not contain whitespace — JWT in query string breaks WebSocket auth. */
export function normalizeSupabaseAnonKey(raw: string | undefined): string {
  return String(raw ?? '').replace(/\s+/g, '').trim();
}
